// 약관 문서 콘텐츠. /policy?doc=terms|privacy|location|company 에서 렌더.
// 공개 약관 원문. 화면에는 검토 메모나 내부 작성 상태를 표시하지 않는다.
//  마크다운 유사 문법(## 제목 / ### 소제목 / - 목록).
//
//  ★ 이 파일이 앱까지 포함한 약관 본문의 단일 소스다.
//    iOS SignupTermsView 는 상세보기를 `{웹}/policy?doc=...` 인앱 브라우저로 열기 때문에,
//    여기만 고치면 앱 재빌드 없이 반영된다. (동의 "항목" 목록은 웹 util/consent.js ·
//    iOS SignupTermsView · 백엔드 REQUIRED_TERMS 3곳 계약이라 별개.)

// 법정 표기용 사업자 정보 — 문서 여러 곳에서 재사용하므로 여기서만 고친다.
export const COMPANY_INFO = {
  name: "앙꼬르",
  ceo: "이제이",
  bizNo: "139-23-02396",
  // 신고 완료 후 번호만 입력하면 홈 하단과 사업자 정보 문서에 자동 노출된다.
  mailOrderNo: "",
  jobInfoProviderNo: "",
  address: "울산광역시 북구 천마로 95, 2층(달천동)",
  tel: "0502-1929-7300",
  email: "muyeon.app@gmail.com",
  // 전자상거래법상 표시 의무 항목. 서버는 AWS EC2 에 있다 —
  //  가비아는 도메인을 등록·관리하는 곳이지 호스팅 제공자가 아니다.
  hosting: "Amazon Web Services, Inc.",
  marketplaceNotice: "무용연은 통신판매중개자로서 통신판매의 당사자가 아니며 개별 판매자가 제공하는 서비스에 대한 이행 계약사항 등과 관련한 의무와 책임은 거래당사자에게 있습니다.",
  privacyOfficer: { name: "유민호", email: "minho082724@gmail.com", tel: "010-5522-7514" },
  effectiveDate: "2026년 8월 30일",
};

const C = COMPANY_INFO;
// 약관 원문에만 표시한다. PG 심사가 끝날 때까지 홈 하단 사업자 정보에는 노출하지 않는다.
const TERMS_MAIL_ORDER_NO = "제 2026-울산북구-0279 호";
const optionalCompanyLines = [
  C.mailOrderNo && `- 통신판매업 신고번호: ${C.mailOrderNo}`,
  C.jobInfoProviderNo && `- 직업정보제공사업 신고번호: ${C.jobInfoProviderNo}`,
].filter(Boolean).join("\n");

const TERMS = `## 무용연 이용약관

본 약관은 무용 강사·학원·공연팀·무용수 등 무용 분야 구성원과 이용자를 연결하는 "무용연" 서비스의 이용에 관한 사항을 정합니다.

### 제1조 (목적)
이 약관은 ${C.name}(이하 "회사")이 운영하는 무용연 모바일 앱 및 웹 서비스(이하 "서비스")의 이용과 관련하여 회사와 회원의 권리·의무 및 책임사항을 규정함을 목적으로 합니다.

### 제2조 (정의)
1. "회원"은 이 약관에 동의하고 서비스 이용계약을 체결한 사람을 말합니다.
2. "일반 회원"은 레슨·체험수업 등 무용 관련 서비스를 이용하거나 강사·학원 등에 견적을 요청하는 회원을 말합니다.
3. "전문가 회원"은 강사·학원·공연팀·무용수 등 자신의 전문 활동 유형을 등록하거나 인증받아 무용 관련 정보 또는 용역을 제공하는 회원을 말합니다.
4. "게시물"은 회원이 서비스에 등록하거나 전송하는 프로필, 이력서, 공고, 견적, 후기, 글, 댓글, 채팅, 이미지, 영상 및 문서를 말합니다.
5. "거래"는 회원 사이에서 이루어지는 레슨, 체험수업, 채용, 캐스팅 및 회사가 제공하는 그 밖의 연결 서비스를 말합니다.

### 제3조 (약관의 게시·효력·변경)
1. 회사는 회원이 쉽게 확인할 수 있도록 이 약관을 서비스 화면에 게시합니다.
2. 회사는 관계 법령을 위반하지 않는 범위에서 약관을 변경할 수 있습니다.
3. 약관을 변경하는 경우 적용일과 변경 내용을 적용일 7일 전부터 알립니다. 회원에게 불리하거나 중대한 변경은 30일 전에 서비스 공지, 이메일 또는 앱 알림 등 합리적인 방법으로 알립니다.
4. 관계 법령에 따라 별도 동의가 필요한 변경은 회원의 단순한 서비스 계속 이용만으로 동의한 것으로 처리하지 않습니다.

### 제4조 (이용계약의 성립)
1. 이용계약은 이용 희망자가 필수 약관에 동의하고 회원가입을 신청하여 회사가 이를 승낙한 때 성립합니다.
2. 회사는 신청 내용에 허위·누락이 있거나 타인의 명의를 사용한 경우, 서비스의 안전한 운영을 현저히 해칠 우려가 있는 경우 승낙을 거절하거나 사실 확인이 끝날 때까지 보류할 수 있습니다.
3. 회사는 현재 만 14세 미만 아동의 직접 회원가입을 받지 않습니다.

### 제5조 (회원 탈퇴 및 재가입 제한)
1. 회원은 서비스에서 탈퇴를 신청할 수 있습니다. 진행 중인 예약, 잔여 이용권, 이용 중인 유료서비스 또는 상대방의 응답을 기다리는 거래가 있는 경우에는 이를 먼저 정리해야 합니다.
2. 탈퇴가 완료되면 계정 이용은 즉시 중지됩니다. 다른 회원에게 이미 전달된 게시물·후기·채팅 등은 대화와 거래의 연속성을 위해 작성자를 식별할 수 없도록 처리하여 남길 수 있습니다.
3. 회사는 부정한 재가입과 분쟁 회피를 방지하기 위해 탈퇴일부터 3개월간 동일한 이메일 주소, 휴대전화번호 또는 본인확인 식별값을 이용한 재가입을 제한할 수 있습니다.
4. 탈퇴 후 개인정보의 삭제·비식별화·보관은 개인정보처리방침에 따릅니다.

### 제6조 (서비스의 내용)
회사는 다음 서비스를 제공합니다.
- 강사·학원·공연팀·무용수의 프로필과 이력서 등록·열람
- 채용·대타·캐스팅 공고와 지원 관리
- 레슨 정보, 견적 요청, 추천 및 예약 연결
- 회원 간 채팅, 커뮤니티, 댓글, 후기와 문의
- 멤버십, 광고, 결제 등 회사가 별도로 제공하는 유료서비스
- 그 밖에 무용 활동과 거래를 지원하기 위해 회사가 정하는 서비스

### 제7조 (거래 상대방 연락처 제공과 이용)
1. 회사는 인증된 휴대전화번호를 공개 프로필, 공개 이력서, 강사 구인·구직 공고 또는 검색 결과에 표시하지 않습니다.
2. 견적 수락, 예약 확정 또는 수업 완료 등 미리 안내된 거래 단계에 도달한 경우에만 해당 거래 상대방에게 이름 또는 활동명, 인증된 휴대전화번호와 거래에 필요한 일정·장소 정보를 제공합니다.
3. 연락처를 제공받은 회원은 일정 협의, 채용·레슨·예약의 이행, 취소·환불 및 분쟁 처리 목적으로만 이용해야 하며 제3자 공개, 광고 또는 영업 목적으로 이용해서는 안 됩니다.
4. 거래가 취소·종료되거나 회원이 탈퇴하면 회사는 연락처를 일반 거래화면에서 숨기고, 법정 보존이 필요한 거래기록과 분리하여 접근을 제한합니다.

### 제8조 (계정과 인증정보)
1. 회원은 본인의 계정만 사용해야 하며 계정 또는 인증받은 활동 유형을 타인에게 양도·대여·판매해서는 안 됩니다.
2. 강사·무용수의 경력과 자격, 학원·공연팀의 사업자·소속 정보 및 제출한 인증자료는 사실과 일치해야 합니다. 내용이 변경되거나 효력을 잃으면 지체 없이 수정해야 합니다.
3. 타인의 성명, 사진, 사업자등록증, 자격증, 경력증명서, 포트폴리오 또는 소속을 도용하거나 회사·운영자·다른 회원을 사칭해서는 안 됩니다.
4. 허위 또는 변조된 인증자료가 의심되는 경우 회사는 확인자료를 요청하고 확인이 끝날 때까지 인증 표시나 관련 기능을 제한할 수 있습니다.

### 제9조 (프로필·이력서·공고·게시물 기준)
1. 회원은 실제 제공하거나 구하는 내용과 일치하도록 게시물을 정확하게 작성해야 합니다.
2. 다음 게시물을 등록하거나 전송해서는 안 됩니다.
- 허위·과장·기만 정보, 거래 의사 없이 작성한 공고 또는 이미 마감되어 제공할 수 없는 정보
- 같은 내용을 반복 등록한 도배성 게시물이나 서비스 목적과 무관한 광고·홍보·설문·회원 모집
- 타인의 저작권·상표권·초상권·개인정보 등 권리를 침해하는 내용
- 전화번호, 주소, 계좌번호, 신분증 등 본인이나 타인의 개인정보를 불필요하게 공개하는 내용
- 불법 고용, 무등록 영업, 문서 위조, 사행행위, 사기 등 법령을 위반하거나 이를 유도하는 내용
3. 모집이 끝났거나 거래조건이 변경된 경우 작성자는 공고를 마감하거나 내용을 갱신해야 합니다.

### 제10조 (채팅·커뮤니티·댓글·후기)
1. 모든 소통에서 욕설, 모욕, 혐오, 차별, 성희롱, 음란 표현, 협박, 스토킹 및 신체 위해 예고를 금지합니다.
2. 상대방이 명시적으로 거절한 뒤에도 연락을 반복하거나 무용 서비스와 무관한 사적 만남 또는 성적 목적의 연락을 해서는 안 됩니다.
3. 서비스 이용 중 알게 된 이름, 연락처, 일정, 주소, 사진 등 개인정보를 동의 없이 공개하거나 다른 목적으로 이용해서는 안 됩니다.
4. 실제 이용 경험에 근거하지 않은 후기, 대가·할인·환급을 조건으로 작성한 후기, 본인·지인·복수 계정을 이용한 조작 후기를 금지합니다.
5. 사실과 다른 후기, 보복성 후기, 개인정보 침해 또는 모욕적 표현이 포함된 후기는 사실 확인 후 노출을 제한할 수 있습니다.
6. 회사는 음란·폭력·혐오·차별·괴롭힘 등 불쾌하거나 부적절한 콘텐츠와 이를 게시하는 악성 이용자에 대해 무관용 원칙을 적용합니다.
7. 회원은 불쾌한 콘텐츠를 신고하거나 해당 이용자를 차단할 수 있으며, 차단한 이용자의 게시물·댓글·채팅은 회원에게 노출되지 않습니다.

### 제11조 (서비스의 공정한 이용)
1. 실제 채용·수강·거래 의사 없이 지원, 견적, 예약 또는 문의를 만들거나 경쟁자의 조건을 확인할 목적으로 허위 활동을 해서는 안 됩니다.
2. 클릭, 조회, 찜, 지원, 채팅, 후기, 예약, 결제 또는 신고 수를 프로그램이나 반복 행위로 조작해서는 안 됩니다.
3. 서비스 오류, 취약점, 중복 지급 또는 처리 절차를 악용해 부당한 이익을 얻거나 다른 사람에게 악용 방법을 알려서는 안 됩니다.
4. 매크로, 크롤러 등 자동화 도구를 이용해 대량 등록·열람·수집·지원·견적 발송을 하거나 서비스에 과도한 부하를 주어서는 안 됩니다.

### 제12조 (회원과 전문가 회원의 의무)
1. 회원은 관계 법령, 이 약관, 서비스 화면의 이용 안내와 다른 회원의 권리를 준수해야 합니다.
2. 회원은 정확한 거래·연락·일정 정보를 제공하고 확정한 약속을 성실히 이행해야 합니다.
3. 전문가 회원은 프로필·공고·견적의 진실성과 적법성을 확보하고 서비스 제공에 필요한 자격·인허가·시설과 안전조치를 갖추어야 합니다.
4. 전문가는 등록 내용과 현저히 다른 서비스를 제공하거나 사전에 알리지 않은 추가 비용을 현장에서 강요해서는 안 됩니다.
5. 이용자와 전문가는 회사가 제공하는 거래·결제·환불 절차를 조작하거나 다른 회원의 정상적인 이용을 방해해서는 안 됩니다.

### 제13조 (미성년자 보호 및 안전)
1. 미성년자의 개인정보, 사진, 수업 장소와 일정은 서비스 제공에 필요한 최소한으로 처리해야 하며 본인 또는 법정대리인의 동의 없이 공개하거나 이용해서는 안 됩니다.
2. 미성년자를 대상으로 한 성적 표현·접근, 부적절한 사적 연락, 촬영물의 무단 보관·공유, 음주·흡연·불법행위 권유 등 안전을 해치는 행위를 엄격히 금지합니다.
3. 무용 활동에는 부상 위험이 있으므로 전문가는 수업 환경과 참여자의 상태를 확인하고 필요한 안전조치를 해야 하며, 이용자는 안내된 안전수칙을 준수해야 합니다.
4. 범죄 피해가 진행 중이거나 신체 안전이 위협받는 긴급상황에서는 경찰·소방 등 관계기관에 먼저 도움을 요청해야 합니다. 서비스 신고는 긴급 구조 요청을 대신하지 않습니다.

### 제14조 (신고와 사실 확인)
1. 회원은 콘텐츠의 신고 기능 또는 고객문의를 통해 위반이 의심되는 활동을 신고할 수 있습니다.
2. 회사는 신고 내용, 서비스 기록, 당사자의 설명과 제출자료를 확인하고 추가 자료나 소명을 요청할 수 있습니다.
3. 신고 사실만으로 위반이 확정되는 것은 아닙니다. 허위 신고, 괴롭힘 목적의 반복 신고 또는 증거 조작도 이 약관 위반으로 처리할 수 있습니다.
4. 신고자·피신고자의 개인정보와 신고 내용은 신고 처리와 관계 법령상 의무에 필요한 범위에서만 이용합니다.

### 제15조 (위반에 대한 조치)
1. 회사는 위반 내용과 횟수, 고의성, 피해 규모, 시정 여부와 서비스 안전에 미치는 영향을 고려하여 다음 조치 중 하나 이상을 적용할 수 있습니다.
- 안내·경고 또는 내용 수정·삭제 요청
- 게시물·댓글·프로필·공고의 숨김·삭제
- 지원·채팅·예약·결제·광고·판매 등 일부 기능 제한
- 계정의 일시 정지 또는 이용계약 해지
2. 회사는 원칙적으로 조치 사유와 내용을 회원에게 알립니다. 즉각적인 피해 방지, 증거 보전, 보안 또는 관계기관의 요청 등 긴급한 사유가 있으면 먼저 임시조치한 후 알릴 수 있습니다.
3. 중대한 불법행위, 명의·결제 도용, 사기, 안전 침해, 반복 위반 또는 조사 방해는 경고 없이 즉시 제한할 수 있습니다.
4. 위반이 확인되지 않거나 제한 사유가 해소되면 임시조치를 해제합니다.
5. 회사는 신고 접수 후 24시간 이내에 해당 콘텐츠를 삭제하고 작성자의 이용을 제한하거나 계약을 해지할 수 있습니다.

### 제16조 (이의제기)
1. 조치를 받은 회원은 통지를 받은 날부터 14일 이내 고객문의를 통해 설명을 요청하거나 소명과 증빙자료를 제출할 수 있습니다.
2. 회사는 제출자료와 기존 확인내용을 다시 검토하여 조치의 유지·변경·해제 결과를 안내합니다.
3. 기간이 지났더라도 명백한 사실오인이나 새로운 증빙이 확인되면 재검토할 수 있습니다.

### 제17조 (통신판매중개자의 지위와 책임)
1. 회사는 회원 사이의 거래를 연결하는 통신판매중개자이며 실제 레슨·채용·캐스팅 등 회원 간 계약의 당사자가 아닙니다.
2. 거래 대상 서비스의 내용·품질·안전·적법성과 실제 이행에 관한 일차적인 책임은 이를 등록하고 제공한 회원에게 있습니다.
3. 회사가 직접 판매하는 유료서비스와 회사가 직접 수행하는 결제·보관·환불·정산 절차에 관한 책임은 제한하지 않습니다.
4. 회사는 거래 상대방의 정보를 확인할 수 있는 수단을 제공하고, 회원 간 분쟁이 발생한 경우 사실 확인에 필요한 범위에서 협조합니다.

### 제18조 (서비스 제한 및 중단)
1. 회사는 시스템 점검, 통신·결제 장애, 보안사고, 천재지변 등 운영상 또는 기술상 필요한 경우 서비스의 전부 또는 일부를 제한하거나 중단할 수 있습니다.
2. 예정된 중단은 사전에 알리고, 긴급한 경우에는 사후에 지체 없이 알립니다.
3. 회사의 고의 또는 과실로 회원에게 손해가 발생한 경우 관계 법령에 따라 책임을 부담합니다.

### 제19조 (분쟁 해결 및 준거법)
1. 회사와 회원은 서비스 이용과 관련한 분쟁을 원만하게 해결하기 위해 협의합니다.
2. 협의로 해결되지 않는 경우 관계 법령에 따른 분쟁조정기관 또는 관할법원을 이용할 수 있습니다.
3. 이 약관은 대한민국 법령에 따라 규율하고 해석합니다.

### 부칙
이 약관은 ${C.effectiveDate}부터 시행합니다.

### 사업자 정보
- 상호: ${C.name}
- 대표자: ${C.ceo}
- 사업자등록번호: ${C.bizNo}
- 통신판매업 신고번호: ${TERMS_MAIL_ORDER_NO}
${C.jobInfoProviderNo ? `- 직업정보제공사업 신고번호: ${C.jobInfoProviderNo}` : ""}
- 주소: ${C.address}
- 고객센터: ${C.tel}
- 이메일: ${C.email}
- 호스팅서비스 제공자: ${C.hosting}`;

const CONTACT_SHARING_CONSENT = `## 거래 상대방 개인정보 제공 동의

회사는 견적 수락, 예약 확정 또는 수업 완료 등 이용약관에서 정한 거래 단계에 도달한 경우 거래 이행에 필요한 최소한의 개인정보를 다음과 같이 제공합니다.

- 제공받는 자: 회원이 선택하여 거래를 진행하는 해당 수강생, 강사 또는 학원 회원
- 제공 목적: 일정·장소 협의, 레슨·채용·예약의 이행, 취소·환불 및 분쟁 처리
- 제공 항목: 이름 또는 활동명, 인증된 휴대전화번호, 해당 거래의 일정·장소·예약 내용
- 보유·이용기간: 해당 거래 목적 달성 시까지. 다만 제공받은 자가 자신의 단말기·주소록에 저장한 정보는 제공받은 자가 관리하며, 관계 법령에 따른 거래·분쟁 기록은 법정 보존기간까지 분리 보관
- 동의 거부권 및 불이익: 동의를 거부할 수 있으나, 거래 상대방과 연락이 필요한 견적 수락·예약·레슨 이행 기능을 이용할 수 없습니다.

회사는 휴대전화번호를 공개 프로필, 공개 이력서, 강사 구인·구직 공고 또는 검색 결과에 표시하지 않습니다.`;

const PRIVACY_CONSENT = `## 필수 개인정보 수집·이용 안내

회사는 무용연 회원가입과 서비스 제공에 필요한 최소한의 개인정보를 다음과 같이 처리합니다.

### 회원가입·계정관리
- 처리 목적: 가입 의사 확인, 회원 식별·로그인, 계정 유지·관리, 고객문의와 고지사항 전달
- 처리 항목: 이름, 활동명, 이메일 주소, 암호화된 비밀번호, 인증된 휴대전화번호, 보유·활성 회원유형
- 법적 근거: 개인정보 보호법 제15조 제1항 제4호에 따른 계약의 체결·이행 및 회원 요청에 따른 조치
- 보유기간: 회원 탈퇴 시까지. 다만 관계 법령에 따른 보존 의무가 있거나 별도 고지한 부정이용 방지정보는 해당 기간까지 분리 보관

### 휴대전화 본인확인·중복가입 방지
- 처리 목적: 본인확인, 연령 확인, 동일 휴대전화번호·동일인 중복가입과 명의도용 방지
- 처리 항목: 이름, 생년월일, 성별, 내·외국인 구분, 휴대전화번호, 통신사, 본인확인 일시·결과, CI·DI 단방향 해시값
- 법적 근거: 계약 체결 과정에서 회원이 요청한 조치 및 서비스의 안전한 운영을 위한 정당한 이익. 본인확인 화면에서 별도 동의가 필요한 항목은 해당 동의
- 보유기간: 인증 실패·미완료 기록은 7일 이내 삭제. 인증 완료 정보는 회원 탈퇴 시까지, 재가입·부정이용 방지용 해시값은 탈퇴 후 3개월까지 분리 보관

### 약관·동의 기록
- 처리 목적: 약관 동의 및 철회 사실 확인, 법적 의무 이행과 분쟁 대응
- 처리 항목: 동의 항목, 필수·선택 구분, 동의·철회 여부, 문서 버전, 문구 식별값, 처리 일시, 웹·iOS 등 처리 경로
- 법적 근거: 법령상 의무 준수 및 분쟁 대응을 위한 정당한 이익
- 보유기간: 회원 탈퇴 시까지. 분쟁이 발생한 경우 해당 분쟁 해결 시까지 또는 관계 법령상 보존기간

필수 개인정보 수집·이용에 동의하지 않으면 회원가입 및 무용연 서비스를 이용할 수 없습니다. 광고성 정보 수신 등 선택항목은 동의하지 않아도 서비스를 이용할 수 있습니다.`;

const PRIVACY = `## 개인정보처리방침

${C.name}(이하 "회사")는 무용연 모바일 앱 및 웹 서비스(이하 "서비스") 이용자의 개인정보를 보호하고 관련 고충을 신속하게 처리하기 위하여 다음과 같이 개인정보처리방침을 공개합니다.

### 제1조 (개인정보 처리의 원칙)
1. 회사는 「개인정보 보호법」 등 관계 법령에 따라 서비스 제공에 필요한 최소한의 개인정보만 처리합니다.
2. 위치기반서비스 이용약관은 지역 기반 레슨·강사·학원·공고 매칭을 제공하기 위한 필수 약관입니다. 기기의 현재 위치 접근 권한은 위치기반서비스 약관 동의와 별도로, 현재 위치를 사용하는 기능을 실행할 때 요청합니다. 기기 위치 접근을 허용하지 않은 회원은 지역을 직접 선택할 수 있습니다.
3. 회사는 개인정보를 수집할 때 안내한 목적 외로 이용하지 않습니다. 목적이 변경되는 경우 관계 법령에 따라 별도 동의를 받거나 필요한 조치를 합니다.

### 제2조 (처리하는 개인정보)
1. 회원가입·계정 관리
- 이메일 가입: 이름, 활동명, 이메일 주소, 비밀번호의 암호화된 값, 휴대전화번호, 보유·활성 회원유형, 약관 동의 항목·버전·일시
- 카카오 로그인: 카카오 회원 식별번호, 활동명 등 회원이 카카오를 통해 제공하도록 동의한 정보
- Apple 로그인: Apple 회원 식별정보, 인증 토큰, 이름 및 이메일 주소 등 회원이 Apple을 통해 제공하도록 동의한 정보
- 계정 찾기·보안: 이름, 이메일 주소, 휴대전화번호, 이메일 인증 기록, 로그인·부정 이용 기록
2. 휴대전화 본인확인 및 활동 유형 인증
- NICE 본인확인: 이름, 생년월일, 성별, 내·외국인 구분, 휴대전화번호, 통신사, 본인확인 일시·결과, CI·DI의 단방향 해시값
- 활동 유형 인증: 신청 회원유형, 사업자등록번호, 사업자등록증·재직증명서·자격증 등 회원이 제출한 확인자료, 심사 상태·결과·반려 사유·처리 일시
- 회사는 주민등록번호와 CI·DI 원문을 저장하지 않습니다.
3. 프로필·매칭·커뮤니티
- 프로필 사진·소개, 성별, 전공·장르, 학력·경력·자격·수상·공연 이력, 활동·희망 지역과 시간, 급여 조건, 연락수단, 사진·영상·SNS 주소 및 공개 범위
- 공고·이력서·견적·자동견적 설정, 채팅·문의·신고, 게시글·댓글·후기·찜, 소속 신청과 승인 내역
4. 레슨·예약·결제·멤버십
- 레슨·공간·일정·장소·예약·수강권 정보, 예약자와 제공자 정보, 취소·환불·분쟁 내역
- 주문번호, 상품명, 결제·취소·환불 금액과 일시, 결제수단 종류, 결제대행사 거래 식별정보, 멤버십 등급·기간·한도·사용량
- 카드번호·유효기간·비밀번호 등 결제 인증정보는 결제대행사가 직접 처리하며 회사는 원칙적으로 저장하지 않습니다.
5. 서비스 이용 과정에서 자동으로 생성·수집되는 정보
- IP 주소, 접속일시, 기기 식별정보·모델·OS·앱 버전, 브라우저 정보, 쿠키·로컬 저장소 식별자, 푸시 토큰과 알림 설정
- 광고를 통해 웹사이트에 방문한 경우 유입 경로(광고 매체·캠페인·소재 등 링크에 포함된 정보)와 광고 클릭 식별자
- 화면 방문, 검색·클릭·찜·노출·문의·지원·예약·오류 기록, 비정상 이용 기록
- 이용자가 위치 권한을 허용한 경우 현재 위치의 위도·경도와 이를 변환한 주변 지역, 이용자가 직접 선택하거나 게시물에 등록한 지역·주소·장소 좌표
6. 회사는 회원이 입력하거나 업로드한 정보, 서비스 이용 과정에서 자동 생성된 정보, 본인확인·소셜 로그인·결제 과정에서 제휴사업자가 제공한 정보를 수집합니다.

### 제3조 (개인정보의 처리 목적과 법적 근거)
1. 계약 체결·이행 및 회원 요청 처리(개인정보 보호법 제15조 제1항 제4호)
- 회원 식별·가입·로그인, 계정과 활동 유형 관리, 본인확인과 중복가입·부정이용 방지
- 프로필·공고·이력서·견적·채팅·커뮤니티·문의·신고·추천·예약·수강권 서비스 제공
- 주문·결제·자동갱신·취소·환불, 멤버십 등급·공용 한도·사용량·성과 관리
- 고객문의, 분쟁 처리, 고지사항 전달과 서비스 보안·장애 대응
2. 법령상 의무 준수(개인정보 보호법 제15조 제1항 제2호)
- 계약·결제·청약철회·분쟁 기록 보관, 수사기관 등 적법한 요청 대응, 세금·회계 처리
3. 정보주체의 별도 동의에 따른 처리(개인정보 보호법 제15조 제1항 제1호)
- 이벤트·혜택·뉴스레터 등 광고성 정보 발송과 선택형 맞춤 서비스 제공
4. 회사의 정당한 이익을 위한 처리(개인정보 보호법 제15조 제1항 제6호)
- 명의도용·중복가입·부정이용 방지, 서비스 보안, 장애·오류 분석. 회사는 목적과의 관련성, 필요성 및 정보주체의 권리보다 우선하는지를 사전에 검토하고 최소한의 정보만 처리합니다.
5. 회사는 수집 목적과 합리적으로 관련된 범위에서 정보주체에게 불이익이 발생하는지, 추가 이용의 예측 가능성, 안전성 확보조치 등을 고려하여 관계 법령이 허용하는 경우 개인정보를 추가 이용·제공할 수 있습니다.

### 제4조 (보유 및 이용기간)
1. 회원정보는 회원 탈퇴 또는 처리 목적 달성 시까지 보유합니다. 탈퇴 즉시 계정과 공개정보의 노출을 중단하고 다음 기준에 따라 삭제·비식별화합니다.
- 계정·로그인 정보, 이름, 프로필 사진, 소개, 경력·학력·자격·수상·공연 이력, 활동지역·희망조건, SNS 주소와 공개 이력서: 삭제
- 강사·학원·공연팀 등 활동유형 프로필과 공개 공고: 비공개 처리 후 삭제
- 견적 설정, 자동견적 설정, 찜·검색·추천 설정, 기기 토큰과 광고성 정보 수신 설정: 삭제
- 게시글·댓글·후기: 회원이 삭제를 요청하면 삭제하되, 대화의 맥락이나 다른 회원의 권리 보호를 위해 남겨야 하는 경우 작성자·프로필 등 식별정보를 제거하고 "탈퇴한 회원"으로 표시
- 채팅: 상대방에게 이미 전달된 메시지는 대화의 연속성을 위해 "존재하지 않는 회원"이 보낸 메시지로 비식별화하여 남길 수 있으며, 프로필 이미지·휴대전화번호·이메일·첨부파일 등 직접 식별정보는 삭제하거나 접근을 제한
- 부정 재가입 방지에 필요한 이메일·휴대전화번호·CI·DI의 단방향 해시값과 탈퇴 일시: 탈퇴 후 3개월간 다른 정보와 분리 보관 후 삭제
2. 본인확인 미완료·실패 요청 기록은 생성 후 7일 이내 삭제합니다. 완료된 본인확인 결과 중 계정 관리와 중복가입 방지에 필요한 정보는 해당 목적 달성 시까지 보유하며, 회사는 CI·DI 원문 대신 단방향 해시값을 저장합니다.
3. 관계 법령에 따른 거래·분쟁 기록의 구체적인 기간은 제5항에 따릅니다.
4. 일반 채팅 전체를 분쟁 대응 목적으로 일률적으로 장기 보관하지 않습니다. 다만 신고·불만·분쟁이 접수된 경우 해당 사건과 직접 관련된 메시지·첨부자료의 사본을 별도 분리하여 사건 종결일부터 3년간 보관한 후 삭제합니다.
5. 거래기록은 개인정보를 일반 회원정보와 분리하고 접근권한을 최소화하여 다음 기간 동안 법정 보존 목적으로만 처리합니다.
- 표시·광고에 관한 기록: 6개월
- 계약 또는 청약철회 등에 관한 기록: 5년
- 대금결제 및 재화·서비스 공급에 관한 기록: 5년
- 소비자 불만 또는 분쟁처리에 관한 기록: 3년
- 전자금융거래에 관한 기록: 관계 법령이 정한 기간
- 통신사실확인자료에 해당하는 접속 로그: 3개월

### 제5조 (만 14세 미만 아동)
회사는 현재 만 14세 미만 아동의 직접 회원가입을 받지 않습니다. 만 14세 미만 아동의 개인정보가 법정대리인 동의 없이 수집된 사실을 확인하면 지체 없이 삭제합니다.

### 제6조 (개인정보의 제3자 제공)
1. 회사는 원칙적으로 개인정보를 제3자에게 제공하지 않습니다. 다음의 경우에만 관계 법령이 허용하는 범위에서 제공합니다.
- 정보주체가 사전에 제공받는 자, 목적, 항목 및 보유기간을 확인하고 동의한 경우
- 법률에 특별한 규정이 있거나 법령상 의무를 준수하기 위하여 불가피한 경우
2. 회원은 회원가입 시 이용약관·개인정보 수집·이용 안내와 구분된 "거래 상대방 개인정보 제공 동의"를 확인하고 동의합니다. 회사는 견적 수락·예약 확정·수업 완료 등 거래가 고지된 단계에 도달한 경우에만 다음과 같이 최소한의 정보를 제공합니다.
- 제공받는 자: 해당 거래의 수강생, 강사 또는 학원 회원
- 제공 목적: 일정·장소 협의, 레슨·채용·예약의 이행, 취소·환불 및 분쟁 처리
- 제공 항목: 이름 또는 활동명, 인증된 휴대전화번호, 해당 거래의 일정·장소·예약 내용
- 제공 시점: 견적 수락, 예약 확정 또는 수업 완료 등 화면과 이용약관에서 미리 고지한 단계
- 보유기간: 거래 목적 달성 시까지. 다만 상대방 단말기·주소록에 저장된 정보는 제공받은 자가 관리하며, 법정 거래·분쟁 기록은 해당 기간까지 분리 보관
3. 회사는 연락처가 최초로 제공되는 시점에 제공받는 자, 제공 목적, 제공 항목 및 보유·이용기간을 회원이 확인할 수 있도록 안내합니다.
4. 휴대전화번호 등 비공개 연락수단은 강사 구인·구직 공고, 공개 이력서, 공개 프로필 및 검색 결과에 표시하지 않습니다. 거래 과정에서 연락수단을 제공받은 회원은 해당 거래의 이행과 분쟁 처리 외의 목적으로 이용하거나 제3자에게 공개해서는 안 됩니다.
5. 공개로 설정한 프로필·공고·이력서·게시물 중 회원이 공개하기로 선택한 항목은 다른 회원 또는 비회원에게 표시될 수 있습니다. 회원은 제공 화면에서 공개 범위를 확인·변경할 수 있습니다.

### 제6조의2 (활동유형 인증서류)
1. 회사는 강사·학원·공연팀 등 활동유형 확인을 위해 사업자등록증, 재직증명서, 자격증 등 필요한 최소한의 자료만 요청합니다. 회원은 주민등록번호, 상세주소 등 심사에 필요하지 않은 정보를 가린 뒤 제출해야 합니다.
2. 원본서류는 권한을 부여받은 심사 담당자만 열람하며 일반 회원과 외부 검색 결과에 공개하지 않습니다.
3. 원본서류는 심사 결과 통지 후 이의신청·재검토를 위한 30일이 지나면 삭제합니다. 이의신청이 제기된 경우 최종 결과 통지일부터 30일이 지나면 삭제합니다.
4. 인증 상태, 인증 유형, 심사 결과·일시, 서류 종류와 유효기간 등 원본이 아닌 최소한의 인증 이력은 회원 탈퇴 시까지 보관합니다. 허위서류·명의도용 신고가 접수된 경우 관련 사본은 사건 종결일부터 3년간 별도 분리하여 보관한 후 삭제할 수 있습니다.

### 제7조 (개인정보 처리업무의 위탁)
회사는 원활한 서비스 제공을 위해 개인정보 처리업무의 일부를 다음과 같이 위탁하며, 관계 법령에 따라 수탁자를 관리·감독합니다.
- Amazon Web Services, Inc.: 서버·데이터베이스·파일 보관과 백업 / 서비스에 저장되는 개인정보 / 회원 탈퇴 또는 위탁계약 종료 시까지. 법정 보존정보는 해당 기간
- Google LLC(Firebase Cloud Messaging): 앱 푸시 알림 발송 / 푸시 토큰, 기기·앱 정보, 알림 내용 / 토큰 삭제, 회원 탈퇴 또는 위탁계약 종료 시까지
- NICE평가정보 주식회사: 휴대전화 본인확인 / 이름, 생년월일, 성별, 내·외국인 구분, 휴대전화번호, 통신사와 인증정보 / 본인확인 목적 달성 후 지체 없이 파기. 관계 법령상 보존의무가 있는 경우 해당 기간
- 주식회사 카카오: 카카오 계정 로그인 인증 / 카카오 회원 식별정보와 이용자가 제공에 동의한 정보 / 연동 해제, 탈퇴 또는 위탁계약 종료 시까지
- Apple Inc.: Apple 계정 로그인 인증 / Apple 회원 식별정보, 인증정보와 이용자가 제공에 동의한 정보 / 연동 해제, 탈퇴 또는 관계 법령·Apple 정책이 정한 기간
- 토스페이먼츠 주식회사: 결제수단 인증·등록, 결제 승인, 정기결제, 취소·환불과 거래 검증 / 주문번호, 상품명, 결제금액, 결제수단과 거래 식별정보 / 전자상거래·전자금융 관계 법령상 보존기간 또는 위탁계약 종료 시까지
수탁자나 위탁업무가 변경되면 본 방침을 통해 공개합니다. 실제로 이용하지 않는 사업자에게 개인정보를 전달하지 않습니다.

### 제8조 (개인정보의 국외 이전)
국외 이전의 법적 근거는 개인정보 보호법 제28조의8 제1항 제3호 가목에 따른 계약 이행을 위한 처리위탁·보관입니다.
- Google LLC(Firebase, privacy.google.com/support): 푸시 토큰, 기기·앱 정보와 알림 내용 / 푸시 발송과 전송상태 관리 / 알림 등록·발송 시 정보통신망을 통해 이전 / 미국 등 Google 처리시설 / 토큰 삭제, 회원 탈퇴 또는 위탁계약 종료 시까지
- Apple Inc.(apple.com/legal/privacy/contact): Apple 회원 식별정보와 인증정보 / Apple 로그인 / 로그인·토큰 검증 시 정보통신망을 통해 이전 / 미국 등 Apple 처리시설 / 연동 해제, 탈퇴 또는 관계 법령·Apple 정책이 정한 기간
- Meta Platforms, Inc.(facebook.com/privacy/policy): 제11조 제3항의 행태정보 / 광고 성과 측정과 광고 최적화 / 웹사이트 방문 시 Meta 픽셀을 통해 정보통신망으로 이전 / 미국 등 Meta 처리시설 / Meta 개인정보처리방침이 정한 기간
이용자는 기기의 알림 권한을 끄거나 Apple 로그인을 선택하지 않는 방법으로 선택 기능의 국외 이전을, 브라우저의 제3자 쿠키 차단으로 행태정보의 국외 이전을 거부할 수 있습니다. 국외 이전 거부 요청은 개인정보 보호책임자에게 할 수 있으며, 이전이 필수적으로 수반되는 기능은 이용이 제한될 수 있습니다. AWS의 실제 운영 리전과 데이터 이전 여부는 운영 환경 변경 시 확인하여 국외 이전 항목에 반영합니다.

### 제9조 (개인정보의 파기)
1. 회사는 보유기간이 끝나거나 처리 목적이 달성된 개인정보를 지체 없이 파기합니다. 법령에 따라 계속 보관해야 하는 경우 다른 개인정보와 분리하여 해당 목적으로만 이용합니다.
2. 전자적 파일은 복구·재생하기 어려운 방법으로 삭제하고, 종이 문서는 분쇄 또는 소각합니다.
3. 탈퇴 계정의 게시물·거래 기록을 보관하는 경우 이름과 프로필 이미지를 제거하거나 "탈퇴한 회원"으로 표시하는 등 식별 가능성을 낮춥니다.

### 제10조 (정보주체와 법정대리인의 권리)
1. 이용자는 언제든지 서비스의 개인정보 관리·설정·회원 탈퇴 기능 또는 고객문의를 통해 개인정보 열람, 전송, 정정·삭제, 처리정지, 동의철회 및 탈퇴를 요청할 수 있습니다.
2. 대리인을 통한 권리 행사의 경우 회사는 위임장과 본인·대리인 확인자료를 요청할 수 있습니다.
3. 회사는 요청자가 본인 또는 정당한 대리인인지 확인한 뒤 관계 법령이 정한 기간 안에 처리 결과를 안내합니다. 정정·삭제 요청을 받은 정보는 처리가 끝날 때까지 원칙적으로 이용하거나 제공하지 않습니다.
4. 다른 법령에서 보존하도록 정한 정보이거나 타인의 권리 침해 우려가 있는 경우 등 관계 법령이 정한 사유가 있으면 권리 행사가 제한될 수 있으며, 이 경우 사유와 이의제기 방법을 안내합니다.

### 제11조 (쿠키와 행태정보)
1. 회사는 로그인 유지, 보안, 이용 현황 분석과 지역·장르·검색·클릭·찜·예약·회원유형 등에 따른 콘텐츠·강사·학원·공고 추천을 위해 쿠키, 로컬 저장소 및 서비스 이용기록을 처리할 수 있습니다.
2. 수집 항목은 방문·검색·클릭·찜·노출·구매·예약 기록, 기기·브라우저 정보와 내부 식별정보이며, 웹·앱 실행과 기능 이용 시 자동 수집됩니다. 서비스 제공과 추천에 필요한 기간 동안 보유한 후 목적 달성 또는 회원 탈퇴 시 파기하되 법정 보유기간이 있으면 그 기간을 따릅니다.
3. 회사는 광고 성과 측정과 광고 최적화(광고를 볼 가능성이 높은 이용자에게 노출)를 위해 무용연 웹사이트에서 아래 광고사업자가 행태정보를 수집하도록 허용합니다. 무용연 모바일 앱 안에서는 수집하지 않습니다.
- 행태정보를 수집·처리하는 사업자: Meta Platforms, Inc.(Facebook·Instagram 운영사)
- 수집 항목: 방문한 웹페이지 주소, 화면 열람·작성 시작·게시물 등록·회원가입 등 이용 이벤트, 쿠키 식별자, 광고 클릭 식별자, 브라우저·기기 정보, IP 주소
- 수집 방법: 웹사이트 방문 시 Meta 픽셀(스크립트)을 통해 자동 수집
- 이용 목적: 광고 노출·클릭 이후의 이용 결과 측정, 광고 최적화와 관심 기반 광고 노출
- 보유·이용기간: 회사는 위 정보를 별도로 보관하지 않으며, Meta Platforms, Inc.는 자사 개인정보처리방침(facebook.com/privacy/policy)이 정한 기간 동안 보유합니다.
- 회사는 이 과정에서 이름, 연락처, 이메일, 게시물·채팅 내용을 광고사업자에게 보내지 않습니다.
4. 이용자는 브라우저의 쿠키 차단·삭제, 기기의 추적·위치·알림 권한 설정을 통해 자동수집을 제한할 수 있습니다. 다만 로그인 유지, 주변 추천 등 일부 기능이 제한될 수 있습니다.
- 맞춤형 광고 거부: 브라우저 설정에서 제3자 쿠키를 차단하거나, Facebook·Instagram 계정의 광고 설정(accountscenter.facebook.com/ad_preferences)에서 파트너 활동 정보 기반 광고를 끌 수 있습니다.
- 행태정보 관련 문의·피해 신고는 제14조의 개인정보 보호책임자에게 할 수 있습니다.
5. 추천은 입력한 지역·장르·조건과 서비스 이용기록 등을 기준으로 콘텐츠의 표시 순서를 정하는 기능이며, 법적 효과나 회원의 권리·의무에 중대한 영향을 미치는 완전 자동화된 결정을 하지 않습니다.

### 제11조의2 (광고성 정보 수신)
1. 회사는 서비스 운영에 필수적인 예약·결제·채팅·보안 알림과 이벤트·혜택 등 광고성 정보를 구분합니다.
2. 광고성 정보는 선택 동의를 받은 채널로만 발송하며 이메일, SMS·알림톡, 앱 푸시 동의를 각각 구분하여 기록합니다.
3. 회원은 각 채널의 수신 동의를 하지 않아도 기본 서비스를 이용할 수 있고, 마이페이지 알림 설정 또는 고객문의를 통해 채널별로 언제든지 철회할 수 있습니다.
4. 회사는 동의 항목, 채널, 동의·철회 여부, 문서 버전 및 처리 일시를 건별로 보관합니다.

### 제12조 (개인위치정보)
1. 회사는 이용자가 위치 권한을 허용한 경우 현재 위도·경도를 주변 지역으로 변환하여 가까운 레슨·강사·학원·공고를 보여주는 데 이용합니다. 권한을 허용하지 않아도 지역을 직접 선택할 수 있습니다.
2. 게시자가 레슨·공간·일정에 직접 등록한 주소와 장소 좌표는 해당 게시물·예약·일정의 제공과 지도 표시에 이용됩니다.
3. 개인위치정보의 이용, 보유·파기와 이용자의 권리에 관한 자세한 사항은 위치기반서비스 이용약관을 따릅니다.

### 제13조 (안전성 확보조치)
회사는 개인정보의 안전한 처리를 위해 내부 관리계획 수립, 개인정보취급자와 접근권한 최소화, 비밀번호 및 주요 식별정보 암호화·해시 처리, 전송구간 보호, 접속기록 보관·점검과 위·변조 방지, 보안 업데이트·백업, 침해사고 대응 등 기술적·관리적 조치를 시행합니다.

### 제14조 (개인정보 보호책임자와 문의)
- 개인정보 보호책임자: ${C.privacyOfficer.name}
- 이메일: ${C.privacyOfficer.email}
- 연락처: ${C.privacyOfficer.tel}
- 일반 고객문의: ${C.email}
이용자는 개인정보 처리와 관련한 문의, 불만, 피해구제 및 권리 행사를 위 연락처로 요청할 수 있습니다.

### 제15조 (권익침해 구제방법)
개인정보 침해에 대한 상담이나 구제가 필요한 경우 다음 기관에 문의할 수 있습니다.
- 개인정보침해 신고센터: privacy.kisa.or.kr / 국번 없이 118
- 개인정보 분쟁조정위원회: kopico.go.kr / 1833-6972
- 대검찰청: spo.go.kr / 국번 없이 1301
- 경찰청: ecrm.police.go.kr / 국번 없이 182

### 제16조 (외부 서비스의 개인정보처리방침)
서비스에 포함된 외부 웹사이트·앱·지도 등의 링크를 통해 이동한 뒤 해당 외부 사업자가 개인정보를 처리하는 경우에는 그 사업자의 개인정보처리방침이 적용됩니다.

### 제17조 (변경 고지와 시행)
1. 본 방침의 내용이 변경되는 경우 시행 7일 전부터 서비스 공지사항 등을 통해 알립니다. 이용자 권리에 중대한 변경이 있거나 별도 동의가 필요한 경우에는 30일 전에 알리고 관계 법령에 따른 절차를 진행합니다.
2. 서비스 최초 출시 시에는 신구대비표 없이 본 방침의 공고일과 시행일을 표시할 수 있습니다. 출시 후 방침을 변경하는 경우에는 이전 버전을 열람할 수 있도록 보관하고 주요 변경사항을 알립니다.
3. 공고일: 2026년 10월 21일
4. 시행일: 2026년 10월 21일
5. 주요 변경사항(2026년 10월 21일 시행): 광고 성과 측정을 위한 웹사이트 행태정보 수집(Meta 픽셀) 내용을 제2조·제8조·제11조에 추가`;

const LOCATION = `## 위치기반서비스 이용약관

본 약관은 ${C.name}(이하 "회사")가 운영하는 무용연 모바일 앱 및 웹 서비스(이하 "서비스")의 위치기반서비스 이용에 관한 사항을 정합니다.

### 제1조 (목적)
이 약관은 회사가 위치정보를 이용하여 제공하는 서비스와 관련하여 회사와 개인위치정보주체인 회원의 권리·의무 및 책임사항을 규정함을 목적으로 합니다.

### 제2조 (약관의 효력 및 변경)
1. 이 약관은 회원이 회원가입 또는 위치기반 기능 이용 과정에서 내용을 확인하고 동의하면 효력이 발생합니다.
2. 회사는 관계 법령을 위반하지 않는 범위에서 서비스 변경 등을 반영하기 위해 이 약관을 개정할 수 있습니다.
3. 회사가 약관을 변경하는 경우 적용일과 변경 사유를 적용일 7일 전부터 서비스에 공지합니다. 회원에게 불리하거나 중대한 변경은 원칙적으로 30일 전에 공지하고 필요한 경우 이메일, 앱 알림 등으로 개별 안내합니다.
4. 회원이 변경된 약관에 동의하지 않으면 위치 권한을 해제하거나 위치기반 기능 또는 서비스 이용을 중단하고 이용계약을 해지할 수 있습니다.

### 제3조 (관계 법령의 적용)
이 약관에서 정하지 않은 사항은 「위치정보의 보호 및 이용 등에 관한 법률」, 「개인정보 보호법」, 서비스 이용약관 및 관계 법령에 따릅니다.

### 제4조 (위치기반서비스의 내용)
회사는 다음의 위치기반서비스를 제공합니다.
- 주변 지역 설정: 회원이 기기 또는 브라우저에서 위치 권한을 허용하면 현재 위도·경도를 가장 가까운 시·도 또는 시·군·구로 변환하여 대표 지역을 설정합니다.
- 지역 기반 추천·검색: 회원이 현재 위치로 설정하거나 직접 선택한 지역을 기준으로 가까운 레슨, 강사, 학원, 공고, 공연 및 공간 등을 추천·검색·필터링합니다.
- 장소·지도 표시: 회원이 레슨·공간·일정 등에 직접 등록한 주소와 장소 좌표를 해당 게시물, 예약, 일정 및 지도 화면에 표시합니다.

### 제5조 (개인위치정보의 이용 및 보유)
1. 현재 위치는 회원이 기능을 이용할 때 기기 또는 브라우저의 위치 기능을 통해 확인하며, 가까운 지역을 찾기 위해 회사 서버로 전송될 수 있습니다.
2. 현재 위치를 변환하여 얻은 대표 지역과 회원이 직접 선택한 지역은 서비스 설정 유지를 위해 기기 또는 계정 정보에 저장될 수 있습니다.
3. 게시자가 직접 등록한 주소와 장소 좌표는 게시물·예약·일정이 유지되는 동안 보유하고, 해당 정보가 공개된 경우 다른 이용자에게 표시될 수 있습니다.
4. 회사는 위치정보 이용·제공사실 확인자료를 관계 법령에 따라 자동으로 기록하고 법령이 정한 기간 동안 보관합니다. 법령상 보존 의무가 있는 자료는 그 목적에만 이용합니다.
5. 회사는 이용·제공 목적을 달성하여 더 이상 필요하지 않은 개인위치정보를 지체 없이 파기합니다. 다만 다른 법령에 따라 보존해야 하거나 회원이 별도로 동의한 경우에는 해당 기간 동안 보관합니다.

### 제6조 (개인위치정보의 제3자 제공)
1. 회사는 현재 회원의 실시간 위치 또는 현재 위치 좌표를 제3자에게 제공하지 않습니다.
2. 향후 회원이 지정한 제3자에게 개인위치정보를 제공하는 기능을 도입하는 경우, 제공받는 자와 제공 목적을 사전에 알리고 동의를 받으며 관계 법령에 따라 제공받는 자, 제공일시 및 제공목적을 회원에게 통보합니다.
3. 회원이 공개 게시물에 직접 등록한 주소와 장소 좌표의 표시는 제5조 제3항에 따릅니다.

### 제7조 (회원의 권리 및 행사방법)
1. 회원은 언제든지 위치기반서비스 이용과 개인위치정보의 제3자 제공에 대한 동의의 전부 또는 일부를 철회하거나 일시적인 중지를 요구할 수 있습니다.
2. 회원은 기기·브라우저 설정에서 위치 권한을 해제할 수 있습니다. 위치 권한을 허용하지 않아도 지역을 직접 선택하여 서비스를 이용할 수 있습니다.
3. 회원은 다음 자료의 열람·고지 또는 오류의 정정을 요구할 수 있습니다.
- 본인에 대한 위치정보 이용·제공사실 확인자료
- 본인의 개인위치정보가 관계 법령에 따라 제3자에게 제공된 이유와 내용
4. 회원은 서비스 설정 또는 고객문의를 통해 권리를 행사할 수 있으며, 회사는 본인 여부를 확인한 뒤 관계 법령이 정한 절차에 따라 처리합니다.
5. 동의를 철회하면 회사는 철회 범위에 해당하는 개인위치정보를 파기합니다. 다만 법령상 보존 의무가 있는 위치정보 이용·제공사실 확인자료는 정해진 기간 동안 보관합니다.

### 제8조 (만 14세 미만 아동 등)
1. 회사는 현재 회원가입 과정에서 만 14세 이상임을 확인하며, 만 14세 미만 아동의 직접 회원가입과 개인위치정보 이용을 받지 않습니다.
2. 만 14세 미만 아동의 개인위치정보가 법정대리인의 동의 없이 처리된 사실을 확인하면 지체 없이 이용을 중단하고 해당 정보를 파기합니다.
3. 회사가 향후 만 14세 미만 아동 또는 관계 법령에서 정한 8세 이하 아동 등의 개인위치정보를 처리하는 서비스를 제공하는 경우에는 법정대리인 또는 보호의무자의 동의 확인과 권리 보장 절차를 마련하고 약관에 반영합니다.

### 제9조 (서비스 이용요금 및 통신료)
1. 위치기반 기능은 무료로 제공합니다. 다만 위치기반 기능과 연결된 별도의 유료 상품·서비스는 해당 구매 화면과 관련 약관에 표시된 조건을 따릅니다.
2. 서비스 이용 중 발생하는 데이터 통신료는 회원이 가입한 이동통신사 또는 인터넷 서비스 제공자의 정책에 따라 회원이 부담합니다.

### 제10조 (서비스의 변경·제한 및 중지)
1. 회사는 위치기반서비스를 추가하거나 중요 내용을 변경하는 경우 제2조에 따라 공지합니다.
2. 설비 점검·보수, 통신 장애, 재난, 국가비상사태, 서비스 이용 폭주 또는 회원의 법령·약관 위반 등으로 정상적인 운영이 어려운 경우 서비스의 전부 또는 일부를 제한하거나 중지할 수 있습니다.
3. 회사는 제한·중지 사유와 기간을 사전에 공지하며, 긴급하거나 불가피한 경우에는 사후에 지체 없이 공지할 수 있습니다.

### 제11조 (손해배상 및 책임)
1. 회사가 관계 법령을 위반하여 회원에게 손해가 발생한 경우 회원은 관계 법령에 따라 손해배상을 청구할 수 있습니다.
2. 회원이 이 약관 또는 관계 법령을 위반하여 회사에 손해를 발생시킨 경우 관계 법령에 따라 그 손해를 배상할 책임이 있습니다.
3. 천재지변, 통신망 장애 등 회사가 합리적으로 통제하기 어려운 사유로 서비스를 제공하지 못한 경우 회사의 책임은 관계 법령이 정하는 범위로 제한됩니다.

### 제12조 (분쟁 해결 및 관할)
1. 회사와 회원은 위치정보와 관련한 분쟁을 원만하게 해결하기 위해 성실히 협의합니다.
2. 협의가 이루어지지 않는 경우 관계 법령에 따라 방송통신위원회에 재정을 신청하거나 개인정보분쟁조정위원회에 조정을 신청할 수 있습니다.
3. 이 약관은 대한민국 법률을 적용하며, 소송이 필요한 경우 「민사소송법」이 정한 관할법원에 제기합니다.

### 제13조 (위치정보관리책임자)
회사는 위치정보를 적절히 관리·보호하고 관련 불만을 처리하기 위하여 다음과 같이 위치정보관리책임자를 지정합니다.
- 성명: ${C.privacyOfficer.name}
- 이메일: ${C.privacyOfficer.email}
- 연락처: ${C.privacyOfficer.tel}

### 제14조 (회사의 연락처)
- 상호: ${C.name}
- 대표자: ${C.ceo}
- 사업자등록번호: ${C.bizNo}
- 주소: ${C.address}
- 고객센터: ${C.tel}
- 이메일: ${C.email}

### 부칙
1. 공고일: 2026년 10월 1일
2. 시행일: 2026년 10월 1일`;

// 전자상거래법 제10조(사업자 정보 표시)에 따른 표기.
//  무용연은 스스로를 통신판매중개자로 규정하므로(이용약관 제10조) 같은 법 제20조의 중개자 고지도 함께 넣는다.
const COMPANY = `## 사업자 정보

### 사업자
- 상호: ${C.name}
- 대표자: ${C.ceo}
- 사업자등록번호: ${C.bizNo}
${optionalCompanyLines}
- 주소: ${C.address}

### 연락처
- 고객센터: ${C.tel}
- 이메일: ${C.email}

### 호스팅서비스 제공자
- ${C.hosting}

### 개인정보 보호책임자
- 성명: ${C.privacyOfficer.name}
- 이메일: ${C.privacyOfficer.email}
- 연락처: ${C.privacyOfficer.tel}

### 통신판매중개자 고지
${C.marketplaceNotice}`;


// 통합 약관 원문.
// 기존 광고·멤버십·예약 약관 URL은 외부 심사자료와 이전 링크의 호환성을 위해
// POLICY_DOCS에서 이 원문으로 연결한다. 취소·환불 정책은 PG 심사가 끝날 때까지
// 별도 문서와 URL을 그대로 유지하며, 이 원문에는 서로 달라질 수 있는 환불 기준을 반복하지 않는다.
const PAID_SERVICES = `## 무용연 유료서비스 이용약관

본 약관은 ${C.name}(이하 "회사")이 운영하는 무용연 모바일 앱 및 웹 서비스에서 제공하는 멤버십, 광고 및 유료 예약 서비스의 이용에 관한 사항을 정합니다.

### 제1조 (목적 및 적용 범위)
1. 이 약관은 유료서비스의 신청, 결제, 이용, 변경 및 해지에 관한 회사와 회원의 권리·의무를 규정합니다.
2. 회사가 직접 판매하는 멤버십·광고와 회사가 결제수단을 제공하는 회원 간 유료 예약에 적용합니다.
3. 회사가 결제수단을 제공하지 않은 회원 간 직접 거래에는 이 약관의 결제·정산 관련 조항을 적용하지 않습니다.

### 제2조 (용어의 정의)
1. "멤버십"은 등급별 등록 한도, 자동견적, 노출 및 성과 정보 등의 혜택을 제공하는 계정 단위 서비스입니다.
2. "광고"는 공고·프로필·레슨 등 회원이 관리하는 대상의 노출 기회를 높이는 유료서비스 또는 멤버십 혜택입니다.
3. "유료 예약"은 회사가 결제수단을 제공하는 레슨·체험수업 등의 예약을 말합니다.
4. "예약금"은 단건 레슨 예약을 확정하기 위해 결제하는 총 레슨비의 일부입니다.
5. "자동결제"는 회원이 동의한 결제주기에 따라 등록된 결제수단으로 다음 이용기간의 요금이 결제되는 방식입니다.
6. "제공자"는 유료 예약의 대상이 되는 레슨·체험수업 등을 등록하고 제공하는 전문가 회원을 말합니다.

### 제3조 (거래조건의 표시와 약관 변경)
1. 회사는 결제 전에 상품명, 제공 내용, 가격, 제공기간, 결제주기, 자동결제 여부, 제공 시기, 해지방법과 취소·환불 조건을 표시합니다.
2. 구체적인 상품 구성과 거래조건은 각 구매·결제 화면에 표시합니다.
3. 회사는 관계 법령을 위반하지 않는 범위에서 이 약관을 변경할 수 있습니다. 변경 내용과 시행일은 7일 전부터 알리며, 회원에게 불리하거나 중대한 변경은 30일 전에 서비스 공지, 이메일 또는 앱 알림 등으로 알립니다.
4. 변경 전에 성립한 계약에는 법령 또는 회원에게 유리한 별도 합의가 없는 한 계약 당시 표시된 거래조건을 적용합니다.

### 제4조 (계약 성립과 결제)
1. 유료서비스 계약은 회원이 거래조건을 확인하고 결제를 신청하여 결제가 승인된 때 성립합니다.
2. 유료 예약은 결제 승인과 서버의 예약 확인이 모두 완료된 때 확정됩니다.
3. 결제수단 인증정보는 결제대행사가 처리하며 회사는 카드번호·유효기간·비밀번호를 직접 저장하지 않습니다. 회사는 결제·자동결제·취소에 필요한 거래 식별정보, 결제 상태와 빌링키 등을 처리할 수 있습니다.
4. 부정한 결제수단 사용, 계정 도용, 중복 결제 또는 결제금액 불일치가 확인된 경우 회사는 계약 성립이나 서비스 제공을 보류하고 사실을 확인할 수 있습니다.

### 제5조 (회원 간 유료거래와 정산)
1. 회사가 회원 간 거래에 결제수단을 제공하는 경우 결제대행사를 통해 대금을 수령하고 제공자에게 지급할 때까지 보관할 수 있습니다.
2. 개인레슨, 학원 체험·1회 수업 및 회사가 결제를 지원하는 그 밖의 예약은 실제 결제 유지금액에서 구매 화면 또는 제공자용 정산 화면에 표시된 중개수수료를 공제한 금액을 제공자 지급 기준금액으로 합니다.
3. 결제대행 비용, 세금, 정산 조건과 실제 정산일은 결제·판매·정산 화면에 표시합니다.
4. 현금영수증·세금계산서 등 거래 증빙은 실제 용역을 제공한 제공자가 발급함을 원칙으로 하며, 회사가 직접 판매한 멤버십·광고 등의 증빙은 회사가 발급합니다.
5. 결제 취소 또는 환불 후 이미 지급된 정산금이 있으면 회사는 제공자에게 반환을 청구하거나 이후 정산금에서 공제할 수 있습니다.

### 제6조 (멤버십 적용 단위)
1. 멤버십은 회원유형별이 아니라 계정당 하나의 등급으로 적용합니다.
2. 여러 활동 유형을 보유하더라도 공고·레슨·자동견적 한도는 계정 전체에서 합산합니다.
3. 활동 유형을 변경하거나 새로운 유형을 인증받아도 멤버십 등급, 이용기간, 결제일 및 남은 한도는 초기화되지 않습니다.
4. 특정 활동 유형 전용 기능은 해당 유형의 인증이 유효한 동안만 제공합니다. 인증이 만료되거나 취소되어도 멤버십은 자동 해지되지 않습니다.

### 제7조 (멤버십 등급과 혜택)
- 무료: 공고 1개, 레슨 1개, 학원·공연팀 인증 회원의 강사 이력서 무료 열람, 자동견적 없음, 멤버십 노출 없음, 성과 미제공
- 베이직: 공고 3개, 레슨 3개, 자동견적 없음, 멤버십 노출 없음, 최근 30일 성과
- 스탠다드: 공고 10개, 레슨 10개, 자동견적 월 100건, 노출 가중치 1, 최근 90일 성과
- 프로: 공고·레슨·자동견적 무제한, 스탠다드의 3배 노출 가중치, 전체 기간 성과, 학원 인증 계정의 학원 운영 도구
- 구체적인 제공 범위와 혜택은 구매 화면에 표시하며, 구매 화면에서 회원에게 더 유리한 혜택을 표시한 경우 그 조건을 적용합니다.

### 제8조 (한도와 노출)
1. 공고·레슨 한도는 공개 또는 모집·판매 중인 항목을 합산하며 임시저장·마감·삭제·비공개 항목은 원칙적으로 제외합니다.
2. 자동견적은 정상 발송된 건만 차감하며 조건 불일치·전송 실패·중복 차단 건은 제외합니다.
3. 월 한도는 대한민국 표준시를 기준으로 매월 새로 계산합니다. 남은 횟수는 이월·양도·환전할 수 없습니다.
4. "무제한"은 정상적인 수동 이용을 전제로 하며 회사는 스팸·자동화·어뷰징 방지를 위한 합리적인 공정사용 기준을 적용할 수 있습니다.
5. 노출 가중치는 추천·정렬에 반영되는 상대적 요소이며 특정 순위, 조회수, 문의, 지원, 예약 또는 거래 성립을 보장하지 않습니다.

### 제9조 (자동결제)
1. 자동결제 상품의 이용료, 결제주기와 다음 결제일은 결제 전 화면과 내 멤버십에 표시합니다.
2. 회원이 다음 결제 전에 자동결제를 해지하지 않으면 등록된 결제수단으로 다음 이용기간의 요금이 결제됩니다. 회사는 결제 완료 사실과 다음 결제 예정일을 안내합니다.
3. 요금 인상 또는 무료·할인 이용 후 유료 전환 시 회사는 30일 전까지 변경 내용, 결제방법과 해지방법을 알리고 관계 법령에 따라 명시적 동의를 받습니다.
4. 결제 실패 시 회사는 3일 간격으로 최대 2회 추가 결제를 시도할 수 있으며 상태와 조치방법을 알립니다. 최종 실패하면 자동결제를 종료하고 무료 등급으로 전환합니다.

### 제10조 (등급 변경·해지·만료)
1. 상위 등급으로 변경하면 남은 기간에 해당하는 차액을 표시하고 결제가 완료된 때 적용합니다.
2. 하위 등급 변경은 원칙적으로 현재 이용기간이 끝난 후 다음 갱신일부터 적용합니다.
3. 회원은 내 멤버십 화면에서 자동결제를 해지할 수 있습니다. 해지는 다음 결제를 중단하는 절차이며 이미 결제한 이용기간이 끝날 때까지 혜택을 이용할 수 있습니다.
4. 이용기간이 끝나면 무료 등급으로 전환되고 유료 전용 기능, 한도, 노출 및 성과 조회 범위가 제한됩니다.
5. 앱 삭제, 로그아웃 또는 활동 유형 변경만으로는 자동결제가 해지되지 않습니다. 회원 탈퇴가 완료되면 향후 자동결제를 중단합니다.

### 제11조 (광고 서비스)
1. 회사는 결제 전에 광고 대상, 노출 위치·방식, 시작·종료 시점, 가격과 대상 변경 가능 여부를 표시합니다.
2. 구매자는 자신이 등록하고 관리 권한을 가진 대상에만 광고를 적용할 수 있습니다.
3. 별도 구매 광고에는 구매 화면의 기간과 조건을 적용하고, 멤버십에 포함된 광고 혜택은 해당 등급과 유효기간 동안 적용합니다.
4. 광고 또는 유료 추천 대상에는 이용자가 알아볼 수 있도록 추천·광고 등의 표시를 할 수 있습니다.
5. 회사는 수집 가능한 노출·클릭·상세열람·지원·문의·예약 등의 성과를 제공할 수 있으나 특정 노출 횟수, 순위, 매출 또는 거래 성립을 보장하지 않습니다.
6. 무효 트래픽, 반복 클릭, 운영 테스트와 부정 이용으로 판단한 기록은 성과에서 제외할 수 있습니다.
7. 허위·과장·중복·불법 게시물, 마감·비공개 대상과 타인의 권리를 침해한 대상은 광고를 거절하거나 중단할 수 있습니다.

### 제12조 (유료 예약의 신청과 확정)
1. 제공자는 서비스 내용, 가격 또는 예약금, 일정·장소·인원, 준비사항, 추가 비용 및 이용 제한사항을 정확하게 표시해야 합니다.
2. 예약금이 있는 레슨은 이용자가 회차를 선택하면 결제 진행 중 해당 정원을 임시 확보하고, 결제 승인과 서버의 예약 확인이 모두 완료된 때 확정됩니다.
3. 결제를 완료하지 않거나 결제 대기 상태가 15분 이상 지속되면 임시 확보한 정원을 해제할 수 있습니다.
4. 잔여 정원 부족, 마감·비공개·종료된 레슨, 과거 회차, 중복 일정, 결제 실패 또는 시스템상 중복 예약이 확인되면 예약이 성립하지 않을 수 있습니다.
5. 결제 승인은 완료됐으나 예약이 확정되지 않은 경우 회사는 상태를 확인하여 예약을 확정하거나 결제 취소 절차를 진행합니다.

### 제13조 (예약금 및 일정 변경)
1. 예약금은 총 레슨비의 일부이며 별도의 이용료가 아닙니다. 회사는 총 레슨비, 지금 결제할 예약금, 현장 결제 예정액과 일정을 결제 전에 표시합니다.
2. 이용자는 확정 상태이며 시작되지 않은 예약을 잔여 정원이 있는 미래 회차로 변경 요청할 수 있습니다.
3. 새 회차 확보에 실패하면 기존 예약을 유지합니다.
4. 일정 변경을 반복하여 취소 기준을 회피하거나 다른 회원의 이용을 방해하는 경우 변경을 제한할 수 있습니다.

### 제14조 (결제 관련 금지행위)
1. 회원은 타인의 결제수단·정산계좌를 사용하거나 결제·완료·노쇼 상태를 허위로 만들어서는 안 됩니다.
2. 회원은 회사가 제공하는 결제·환불 절차를 조작하거나 부당하게 회피하기 위한 외부 결제를 요구해서는 안 됩니다.
3. 제공자는 결제 전에 알리지 않은 추가 비용을 현장에서 강요하거나 정당한 결제 취소·환불 처리에 협조하지 않는 행위를 해서는 안 됩니다.

### 제15조 (결제 오류 및 서비스 장애)
1. 중복·과오 결제, 결제 승인 후 서비스 미반영 또는 예약 미확정이 발생하면 회사는 거래 상태를 확인하여 정상 반영하거나 결제 취소 등 필요한 조치를 합니다.
2. 회사의 장애로 약정한 광고를 제공하지 못하면 미제공 시간만큼 연장하거나 관계 법령과 별도 정책에 따른 조치를 합니다.
3. 시스템 점검, 통신·결제 장애, 보안사고, 천재지변 등으로 유료서비스를 일시적으로 제한하거나 중단할 수 있습니다.
4. 예정된 중단은 사전에 알리고 긴급한 경우에는 사후에 지체 없이 알립니다.

### 제16조 (취소·환불)
1. 유료서비스의 청약철회, 취소, 환불 및 처리 방법은 서비스에 별도로 게시된 "취소·환불 정책"에 따릅니다.
2. 회사는 결제 전에 해당 정책과 주요 조건을 회원이 확인할 수 있도록 제공합니다.
3. 결제 또는 예약 시점에 표시된 조건은 이후 변경으로 회원에게 불리하게 소급하여 적용하지 않습니다.

### 제17조 (기타)
1. 이 약관에서 정하지 않은 사항은 무용연 이용약관과 관계 법령에 따릅니다.
2. 앱마켓 등 외부 사업자가 결제를 처리한 상품은 해당 사업자의 결제 절차와 회사의 이용권 확인·회수 절차를 함께 적용할 수 있습니다.

### 부칙
이 약관은 ${C.effectiveDate}부터 시행합니다.`;

// ─────────────────────────────────────────────────────────────────────────────
// 취소·환불 정책 — 약관에서 환불 조항만 뽑아 한 화면에 모은 문서.
//
//  ★ 왜 별도 문서인가: 카드사 결제경로 심사가 "무형상품 환불규정"을 **한 장으로 캡처**해
//    제출하도록 요구한다(토스페이먼츠 APP 결제경로 제작 가이드 ④). 규정이 멤버십약관 제11조와
//    예약약관 제8조로 흩어져 있으면 캡처가 안 나오고, 심사자도 찾지 못한다.
//  ★ 여기 내용은 새 규정이 아니라 정본의 요약이다. 정본은 멤버십약관 제11조와
//    muyeon-backend/docs/lesson-deposit-policy.md(레슨 예약금 v2, 2026-09-05)이며,
//    레슨 문구는 SlotPickerSheet 의 결제 직전 안내와 글자 단위로 일치시켜야 한다.
//    같은 v2 기준을 이용약관 제8조와 예약 이용약관 제10조에도 반영해 두었다(2026-09-05).
//    셋 중 하나를 고치면 나머지 둘과 SlotPickerSheet·네이티브 예약금 시트까지 함께 고칠 것.
//    둘이 어긋나면 이용자에게 유리한 쪽이 적용된다(아래 제7항에 명시).
//  ★ 디즈니+ 「취소 및 환불 정책 – 대한민국」과 같은 이유로 시행일자를 명시한다 —
//    약관 개정 없이 환불정책만 개정할 수 있어야 한다.
const REFUND_EFFECTIVE_DATE = "2026년 10월 8일";

const REFUND = `## 취소·환불 정책

시행일자: ${REFUND_EFFECTIVE_DATE}

이 정책은 ${C.name}(이하 "회사")가 운영하는 무용연에서 회사가 결제 수단을 제공하여 판매하는 상품의 청약철회·취소·환불 기준을 정합니다. 이 정책에 정하지 않은 사항은 무용연 이용약관, 멤버십 이용약관, 예약 이용약관 및 관계 법령에 따릅니다.

### 1. 적용 범위
- 이 정책은 회사가 결제 수단을 제공한 거래에만 적용됩니다.
- 무용연에서 판매하는 상품은 모두 무형(디지털·용역) 상품이며, 배송이 없습니다.
- 이용자와 제공자가 서비스 밖에서 별도로 체결·결제한 거래에는 적용되지 않으며, 당사자가 합의한 조건과 관계 법령이 적용됩니다.
- 결제는 회사가 안내하는 웹 결제 화면에서 결제대행사를 통해 진행됩니다. iOS 앱에서는 Apple 인앱결제(App Store)로도 멤버십을 결제할 수 있으며, 이 경우 아래 2-2를 따릅니다.

### 2. 무용연 멤버십

#### 2-1. 웹에서 결제한 멤버십
- 결제일부터 7일 이내이고 멤버십 혜택을 이용하지 않은 경우, 환불을 신청하면 결제 금액 전액을 환불합니다.
- 멤버십은 결제가 완료되는 즉시 등급별 기능, 등록 한도, 성과 조회, 노출 혜택의 제공이 시작됩니다. 회사는 결제 전에 즉시 제공 사실과 그에 따른 청약철회 제한 가능성을 표시하고 별도의 확인을 받습니다.
- 위 7일 기준에 해당하지 않는 경우, 위 내용을 확인·동의하여 제공이 시작된 이용기간의 이용료는 원칙적으로 환불하지 않습니다. 다만 환불을 신청하면 회사가 이용 기간과 이용 내역을 확인하여 처리 결과와 환불 금액을 안내합니다.
- 자동결제 해지는 다음 결제를 중단하는 절차이며, 이미 결제된 이용기간을 소급하여 취소하지 않습니다. 해지해도 남은 기간은 그대로 이용할 수 있습니다.
- 멤버십이 표시·광고 또는 계약내용과 다르게 제공된 경우, 공급받은 날부터 3개월 이내 또는 그 사실을 안 날부터 30일 이내에 계약 해제·해지 또는 환불을 요청할 수 있습니다.

다음의 경우에는 위 원칙에도 불구하고 관계 법령에 따라 전액 또는 미제공분을 환불합니다.

- 중복·과오 결제
- 회사의 귀책사유로 멤버십을 정상적으로 제공하지 못한 경우
- 표시·광고 또는 계약내용과 실제 제공 내용이 다른 경우
- 그 밖에 관계 법령상 청약철회, 계약 해제·해지 또는 환불이 인정되는 경우

#### 2-2. iOS 앱에서 Apple 인앱결제로 결제한 멤버십
- 결제와 환불은 Apple이 처리하며, Apple의 이용약관과 환불 정책이 적용됩니다. 회사는 Apple 인앱결제 금액을 직접 환불할 수 없습니다.
- 환불은 Apple에 요청합니다(reportaproblem.apple.com 또는 Apple 고객지원).
- 자동 갱신 해지는 아이폰의 설정 > Apple ID > 구독에서 할 수 있습니다. 해지해도 이미 결제된 기간이 끝날 때까지 그대로 이용할 수 있습니다.
- Apple이 환불을 승인하면 해당 결제로 제공된 이용기간과 혜택은 회수됩니다.

### 3. 레슨 예약금 (단건 레슨)
예약금은 총 레슨비의 일부이며 별도의 이용료가 아닙니다. 예약 시 예약금을 결제하고 나머지 금액은 현장에서 결제합니다. 회사는 결제 전에 제공자(강사·학원) 정보, 총 레슨비, 지금 결제할 예약금, 현장 결제 예정액, 일정과 취소·환불 기준을 함께 표시합니다.

- 수업 시작 24시간 전까지 취소: 결제한 예약금 전액 환불
- 수업 시작 24시간 이내부터 시작 전까지 취소: 결제한 예약금은 환불되지 않습니다
- 수업 시작 후 취소 또는 미참석(노쇼): 이미 제공되었거나 시간 경과로 소진된 것으로 보아 환불하지 않습니다
- 강사·학원의 취소, 연락두절, 수업 미제공: 결제금 전액 환불

- 질병·재난 등 불가항력, 표시·광고 또는 계약과 다른 이행, 제공자와의 별도 합의가 있는 경우에는 위 기준과 별도로 예외 심사합니다.
- 제공자는 상품별로 이 기준보다 이용자에게 유리한 조건을 추가할 수 있으나 불리하게 축소할 수 없습니다. 제공자의 개별 문구와 이 기준이 충돌하면 이용자에게 유리한 조건을 적용합니다.
- 예약 시점에 표시된 정책이 해당 예약에 그대로 적용되며, 이후의 정책 변경은 기존 예약에 소급하지 않습니다.
- 유료 예약의 일정 변경은 1회 요청할 수 있습니다. 강사·학원이 승인하기 전까지는 기존 예약이 유지됩니다.

### 4. 다회권·정기 레슨
단건 예약금 기준을 다회권·정기 레슨에 그대로 적용하지 않습니다. 교습 개시 전에는 관계 법령상 반환 기준에 따라 전액 환급을 원칙으로 하고, 교습 개시 후에는 「학원의 설립·운영 및 과외교습에 관한 법률」 또는 「소비자분쟁해결기준」의 실제 이용분·경과분 기준을 적용합니다.

### 5. 공간대관
공간대관은 현재 서비스를 운영하지 않습니다. 회사가 공간대관에 플랫폼 결제 기능을 제공한다고 표시하는 시점에 적용 기준을 함께 안내합니다.

### 6. 환불 신청과 처리
- 신청 방법(레슨 예약금): 앱 또는 웹의 예약 상세 화면에서 취소하거나, 아래 고객센터로 요청합니다.
- 신청 방법(웹에서 결제한 멤버십): 웹의 MY > 멤버십 > 내 멤버십 · 혜택 보기 > 결제 · 환불에서 환불을 신청하거나, 아래 고객센터로 요청합니다.
- 신청 방법(Apple 인앱결제 멤버십): 2-2에 따라 Apple에 요청합니다.
- 처리 기한: 회사는 환불 사유가 확인된 날부터 3영업일 이내에 환불을 처리합니다.
- 환불 수단: 결제한 수단과 동일한 방법으로 환불함을 원칙으로 합니다. 동일한 방법으로 환불이 불가능한 경우 미리 알리고 다른 방법으로 환불합니다.
- 신용카드로 결제한 경우, 회사가 결제대행사에 취소를 요청하는 것으로 환불 처리에 갈음하며, 카드사의 취소 반영에는 영업일 기준 3~5일이 추가로 걸릴 수 있습니다.
- 환불이 완료되면 해당 결제로 제공된 이용기간과 혜택은 환불 범위에 맞게 회수 또는 조정됩니다.

### 7. 통신판매중개자 고지
${C.marketplaceNotice}

### 8. 정책의 변경과 우선 적용
- 회사는 관계 법령과 서비스 변경에 따라 이 정책을 변경할 수 있으며, 변경 내용과 시행일을 미리 공지합니다. 이용자에게 불리한 변경은 충분한 기간을 두고 알립니다.
- 이 정책과 각 약관의 환불 조항이 서로 다른 경우에는 이용자에게 유리한 기준을 적용합니다.
- 관계 법령이나 「소비자분쟁해결기준」이 이 정책보다 이용자에게 유리한 경우 그 기준을 우선합니다.

### 문의
- 고객센터: ${C.tel}
- 이메일: ${C.email}`;

export const POLICY_DOCS = {
  terms: { title: "이용약관", md: TERMS },
  paid: { title: "유료서비스 이용약관", md: PAID_SERVICES },
  advertising: { title: "유료서비스 이용약관", md: PAID_SERVICES },
  privacyConsent: { title: "필수 개인정보 수집·이용 안내", md: PRIVACY_CONSENT },
  contactSharing: { title: "거래 상대방 개인정보 제공 동의", md: CONTACT_SHARING_CONSENT },
  privacy: { title: "개인정보처리방침", md: PRIVACY },
  location: { title: "위치기반서비스 이용약관", md: LOCATION },
  membership: { title: "유료서비스 이용약관", md: PAID_SERVICES },
  reservation: { title: "유료서비스 이용약관", md: PAID_SERVICES },
  refund: { title: "취소·환불 정책", md: REFUND },
  operation: { title: "이용약관", md: TERMS },
  company: { title: "사업자 정보", md: COMPANY },
};

export const DEFAULT_DOC = "terms";
